import { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { Stack, Box } from '@mui/material'
import Button from '@mui/material/Button'
import Divider from '@mui/material/Divider'
import { updateModal } from '../../../store/common/common_action'
import {
  getReceiveUpdateReceive,
  getUpdateReceiveSecond,
  getReceiveLastReceivePrint,
  getReceiveUpdateReceiveAllV2,
} from '../../../store/branchTransferReceive/branchReceive_action'
import LineInput from '../../common/lineinput'
import { Item } from '../../common/snippets'
import { clickElement, dateFormatWithInputData, focusElemnt, navigation3, toTitleCase } from '../../common/helper'
import jsPDF from 'jspdf'
import autoTable from 'jspdf-autotable'
import moment from 'moment'
import Modal from '../../common/modal'
import ReceivedItem from './ReceivedItem'
import { DEMO_COMPANY, GUJRAT_COMPANY_ID, JAIN_COMPANY_ID, JAIN_NEW, KANKAR_ROADWAYS, RAJESH_TRANSPORT } from '../../../helper/companyIdhardcode'
import { useAtom } from 'jotai'
import { ChallanListAtom, LITReceiveAtom, receiveFilteredTableRowsAtom, receiveFilteredTableSourceAtom, receiveLITLrListAtom, receiveLrListAtom, selectChallanAtom, showListAllAtom } from '../../common/jotaiState/receiveStateAtoms'
import { PostRequest } from '../../common/api'
import { urls } from '../../common/constants'
import { alertAtom, modalAtom } from '../../common/jotaiState/globalStateAtoms'
import { useTranslation } from '../../../i18n/I18nProvider'
import { getValidationMessages } from '../../../i18n/validationMessages'
import { groupData } from '../Reports/userWiseCollReport/utilFucntions'
import { fetchInsertReceiveAllAtom, fetchInsertReceiveAtom, fetchShortReceiveAtom, receiveMemoResultAtom, receivePrintPopupAtom, shortReceiveMemoResultAtom, shortReceivePrintPopupAtom } from '../../common/jotaiState/dispatchStateAtoms'
import { companySettingsAtom } from '../../common/jotaiState/commonStateAtoms'
import { makeTable } from '../Reports/analysisReport/pdfAutotable'
import { lrDetailPdfFooter } from '../AcountingReport/common/AcountingConstants'
import { callAddFontRobotoBold } from '../../common/font/Roboto-bold'
import { callAddFontRobotoMedium } from '../../common/font/Roboto-Medium-normal'
import { withPxWidths } from '../../common/mathHelper'

const ReceiveBottomSection = ({
  getReceiveUpdateReceive,
  getReceiveUpdateReceiveAllV2,
  updateModal,
  getReceiveLastReceivePrint,
  data,
  topSelectedData,
  tSecDropData,
  selectedData,
  setTSecDropData,
  indexSetState,
  setTopSelectedData,
  setSelectedData,
  setShowBtnList,
  handleAlert,
  setResetFlag,
  resetFlag,
  selelectedData
}) => {
  const { translations } = useTranslation()
  const cs = translations?.common || {}
  const rs = translations?.receive || {}
  const error = getValidationMessages(translations)
  const { common, BranchTransferReceiveReducer } = data
  const { strtCity, loginData, strtBrnch, loader, modalType, showModal, roleRights } = { ...common }
  const { receiveReceive, receiveLastReceivePrint } = { ...BranchTransferReceiveReducer }
  const [receiveListData] = useAtom(receiveLrListAtom)
  const [LITReceive,setLITReceive] = useAtom(LITReceiveAtom)
  const [, setReceiveLITLrList] = useAtom(receiveLITLrListAtom)
  const [, setInsertReceive] = useAtom(fetchInsertReceiveAtom)
  const [, setChallanList] = useAtom(ChallanListAtom)
  const [showListAll,setShowListAll]=useAtom(showListAllAtom)
  const [receiveMemoResult, setReceiveMemoResult] = useAtom(receiveMemoResultAtom)
  const [receivePrintPopup, setReceivePrintPopup] = useAtom(receivePrintPopupAtom)
  const [shortReceiveMemoResult] = useAtom(shortReceiveMemoResultAtom)
  const [shortReceivePrintPopup] = useAtom(shortReceivePrintPopupAtom)
  const [, setFetchShortReceive] = useAtom(fetchShortReceiveAtom)
  const [, setInsertReceiveAll] = useAtom(fetchInsertReceiveAllAtom)
  const [selectedChallan, setSelectedChallan] = useAtom(selectChallanAtom)
  const [filteredTableRows] = useAtom(receiveFilteredTableRowsAtom)
  const [filteredTableSource] = useAtom(receiveFilteredTableSourceAtom)
  const [companySettings] = useAtom(companySettingsAtom)
  const { ReceiveChallanPortrait } = companySettings
  const allowShortReceivePrint = [DEMO_COMPANY, KANKAR_ROADWAYS].includes(loginData?.intCompanyID)

  const [, setAlert] = useAtom(alertAtom)
  const [modal,setModal] = useAtom(modalAtom)
  
  const [successModal, setSuccessModal] = useState({
    Receive: { id: 'Receive', lrListLabel: 'Receive popup modal', isSaved: false },
    ShortReceive: { id: 'ShortReceive', lrListLabel: 'Short Receive popup modal', isSaved: false },
    ReceiveSuccess: { id: 'ReceiveSuccess', lrListLabel: 'Receive Success popup modal', isSaved: false },
    ShortReceiveSuccess: { id: 'ShortReceiveSuccess', lrListLabel: 'Short Success Receive popup modal', isSaved: false },
    LastReceivePrint: { id: 'LastReceivePrint', lrListLabel: 'Last Receive Print popup modal', isSaved: false },
    ReceivedItemList: { id: 'ReceivedItemList', lrListLabel: 'Received Item List popup modal', isSaved: false },
  })
  const [selectedPrintData, setSelectedPrintData] = useState(null)
  const [filteredPreviewPdfUrl, setFilteredPreviewPdfUrl] = useState('')
  const [state, setState] = useState({
    Remarks: '',
    LrNo: [],
    BookingId: [],
    shortQtys: [],
    damageQtys: [],
    DipatchIDs: [],
    DispatchDetIDs: [],
    load: false,
    generatePDF: false,
    filteredPreviewGeneratePDF: false,
    received: false,
    lastReceivePrint: false,
    dFromBranchForPrint: '',
  })
  const {
    Remarks,
    LrNo,
    BookingId,
    shortQtys,
    damageQtys,
    DipatchIDs,
    DispatchDetIDs,
    load,
    generatePDF,
    filteredPreviewGeneratePDF,
    received,
    dFromBranchForPrint,
    lastReceivePrint,
  } = state
  const groupDataByKeys = (keys = [], array = []) => {
    return array.reduce((acc, item) => {
      const groupKey = JSON.stringify(keys.map((key) => item?.[key] ?? ''))

      if (!acc[groupKey]) {
        acc[groupKey] = []
      }

      acc[groupKey].push({ ...item, dataType: 'entry' })
      return acc
    }, {})
  }
  const getDispatchDate = (item = {}) => {
    const parentCompanyID = Number(loginData?.CargoParentCompanyID)
    const companyID = Number(loginData?.intCompanyID)
    if (parentCompanyID === 10 && companyID === 11) {
      return '1999-09-09'
    }

    const dispatchDateTime = item?.DispatchDateTime

    if (dispatchDateTime) {
      return dateFormatWithInputData(dispatchDateTime, 'yyyy-MM-dd')
    }

    const vehicleString = item?.VehicleNo
    if (vehicleString && vehicleString.includes(':')) {
      const datePart = vehicleString.split(':')[1]?.trim()
      return dateFormatWithInputData(datePart.split('-'), 'yyyy-MM-dd')
    }

    return '1999-09-09'
  }

  function getNumericMonth(monthAbbr) {
    return String(['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'].indexOf(monthAbbr) + 1).padStart(
      2,
      '0'
    )
  }
  // All UseEffect
  useEffect(() => {
    if (receivePrintPopup) {
      getReceiveLastReceivePrint(selectedData)
      updateModal(true, 'ReceiveSuccess')
      setTSecDropData({ ...tSecDropData, selectconsignmentType: 'All' })
      setSelectedChallan({})
      setState({ ...state, Remarks: '' })
      setShowListAll(false)
      indexSetState({ showListTable: false})
      if (topSelectedData.DFromCity != null) {
        clickElement('BranchReceiveFromCity')
      } if (topSelectedData.DFromBranch != null) {
        clickElement('BranchReceiveFromBranch')
      } if (topSelectedData.SelectedVehicle !== '') {
        clickElement('BranchreceiveVehicleCross')
      }
      setTopSelectedData({
        ...topSelectedData,
        DFromCity: null,
        DFromBranch: null,
        SelectedVehicle: '',
        resetData: true,
        LRNO: '',
      })
      setLITReceive(0)
      setSelectedData([])
      setChallanList([])
      setShowBtnList(true)
    }
  }, [receivePrintPopup])

  useEffect(() => {
    if (selectedData?.length >= 1) {
      const lr = selectedData?.map((item) => item.LRNO)
      const bookingid = selectedData?.map((item) => item.BookingID)
      const DipatchIDs = selectedData?.map((item) => item.DispatchID)
      const dispatchDetIDs = selectedData?.map((item) => item.DispatchDetID)
      const ShortQtys = selectedData.map((item) => 0)
      const DamageQtys = selectedData.map((item) => 0)

      setState({
        ...state,
        LrNo: lr,
        shortQtys: ShortQtys,
        damageQtys: DamageQtys,
        DispatchDetIDs: dispatchDetIDs,
        DipatchIDs: DipatchIDs,
        BookingId: bookingid,
      })
    } else {
      setState({
        ...state,
        LrNo: [],
        shortQtys: [],
        damageQtys: [],
        DipatchIDs: [],
        DispatchDetIDs: [],
      })
    }
  }, [selectedData])

  useEffect(() => {
    if (showModal && modalType === 'FilteredTablePreview' && filteredPreviewGeneratePDF) {
      generateFilteredTablePreviewPdf()
    }
  }, [showModal, modalType, filteredPreviewGeneratePDF])

  useEffect(() => {
    if (receiveReceive?.status === 'Success') {
      getReceiveLastReceivePrint(selectedData)
      updateModal(true, 'ReceiveSuccess')
      setTSecDropData({ ...tSecDropData, selectconsignmentType: 'All' })
      setSelectedChallan({})
      setState({ ...state, Remarks: '' })
      setShowListAll(false)
      indexSetState({ showListTable: false})
      setTopSelectedData({
        ...topSelectedData,
        DFromCity: null,
        DFromBranch: null,
        SelectedVehicle: '',
        resetData: true,
      })
      setLITReceive(0)
      clickElement('BranchReceiveFromCity')
      clickElement('BranchReceiveFromBranch')
      clickElement('BranchreceiveVehicleCross')
      setSelectedData([])
      setChallanList([])
      setShowBtnList(true)
    } else if (receiveReceive?.ErrMessage) {
      handleAlert(receiveReceive.ErrMessage)
    }
  }, [receiveReceive])
  useEffect(() => {
    if (shortReceivePrintPopup) {
      updateModal(true, 'ShortReceiveSuccess')
      setTSecDropData({ ...tSecDropData, selectconsignmentType: 'All', })
      setState({ ...state, Remarks: '', load: false, generatePDF: false })
      setShowListAll(false)
      indexSetState({ showListTable: false})
      setTopSelectedData({
        ...topSelectedData,
        DFromCity: null,
        DFromBranch: null,
        SelectedVehicle: '',
        resetData: true,
      })
      setLITReceive(0)
      clickElement('BranchReceiveFromCity')
      clickElement('BranchReceiveFromBranch')
      clickElement('BranchreceiveVehicleCross')
      setSelectedData([])
      setSelectedChallan({})
      setChallanList([])
      setShowBtnList(true)
    }
  }, [shortReceivePrintPopup])
  //All useEffect End
  const formatPreviewDate = (value) => {
    if (!value) return ''
    const parsed = moment(value)
    return parsed.isValid() ? parsed.format('DD-MM-YYYY') : value
  }

  const isGujaratCompany = loginData?.intCompanyID === GUJRAT_COMPANY_ID

  const getConsignmentType = (item) => {
    if (item?.ConsignmentData?.length > 1) return 'Multi'
    return toTitleCase(item?.ConsignmentData?.[0]?.ConsignmentSubType) || toTitleCase(item?.DescriptionDet) || ''
  }

  const getGujaratReceivePrintColumnDefs = () => [
    { headerName: 'LRNo', exportHead: 'LRNo', field: 'LRNO', xlCol: { dataType: 'string', dataFormatter: null, minCellWidth: 5 }, weight: 60,},
    { headerName: 'Sender', exportHead: 'Sender', field: 'Sender', xlCol: { dataType: 'string', dataFormatter: null, minCellWidth: 5 }, weight: 60,},
    { headerName: 'Receiver', exportHead: 'Receiver', field: 'RecName', xlCol: { dataType: 'string', dataFormatter: null, minCellWidth: 5 }, weight: 60,},
    { headerName: 'FromCity', exportHead: 'FromCity', field: 'FromCity', xlCol: { dataType: 'string', dataFormatter: null, minCellWidth: 5 }, weight: 55,},
    { headerName: 'ToCity', exportHead: 'ToCity', field: 'ToCity', xlCol: { dataType: 'string', dataFormatter: null, minCellWidth: 5 }, weight: 55,},
    { headerName: 'Cons. Type', exportHead: 'Type', field: 'DescriptionDet', xlCol: { dataType: 'string', dataFormatter: null, minCellWidth: 5 }, weight: 50,},
    { headerName: 'TotalAmt', exportHead: 'TotalAmt', field: 'NetAmount', xlCol: { dataType: 'quantity', dataFormatter: null, minCellWidth: 5 }, weight: 50,},
    { headerName: 'PaymentType', exportHead: 'Payment\nType', field: 'PaymentType', xlCol: { dataType: 'string', dataFormatter: null, minCellWidth: 5 }, weight: 50, align: 'center' },
    { headerName: 'Short Qty.', exportHead: 'Short\nQty.', field: 'ShortQty', xlCol: { dataType: 'quantity', dataFormatter: null, minCellWidth: 5 }, weight: 45,},
    { headerName: 'Damage Qty.', exportHead: 'Damage\nQty.', field: 'DamageQty', xlCol: { dataType: 'quantity', dataFormatter: null, minCellWidth: 5 }, weight: 45,},
    { headerName: 'Comment', exportHead: 'Comment', field: 'Comments', xlCol: { dataType: 'string', dataFormatter: null, minCellWidth: 5 }, weight: 70,},
  ]

  const getReceivePrintColumnDefs = () => {
    if (isGujaratCompany) {
      return getGujaratReceivePrintColumnDefs()
    }
    return [
      { headerName: 'Sr. No.', exportHead: 'SN', field: 'srNo', xlCol: { dataType: 'number', dataFormatter: null, minCellWidth: 5 }, weight: 20},
      { headerName: 'LR No.', exportHead: 'LR No.', field: 'LRNO', xlCol: { dataType: 'string', dataFormatter: null, minCellWidth: 5 }, weight: 60},
      { headerName: 'Dispatch Date', exportHead: 'Dispatch\nDate', field: 'BookingDateTime', xlCol: { dataType: 'string', dataFormatter: null, minCellWidth: 5 }, weight: 50},
      { headerName: 'Received Date', exportHead: 'Received\nDate', field: 'ReceivedDate', xlCol: { dataType: 'string', dataFormatter: null, minCellWidth: 5 }, weight: 50},
      { headerName: 'Dispatch By Branch', exportHead: 'Dispatch\nBy Branch', field: 'BookingBranchName', xlCol: { dataType: 'string', dataFormatter: null, minCellWidth: 20 }, weight: 70},
      { headerName: 'Received By Branch', exportHead: 'Received\nBy Branch', field: 'DestinationBranchName', xlCol: { dataType: 'string', dataFormatter: null, minCellWidth: 5 }, weight: 70},
      { headerName: 'Sender Name', exportHead: 'Sender\nName', field: 'Sender', xlCol: { dataType: 'string', dataFormatter: null, minCellWidth: 5 }, weight: 60},
      { headerName: 'Receiver Name', exportHead: 'Receiver\nName', field: 'RecName', xlCol: { dataType: 'string', dataFormatter: null, minCellWidth: 5 }, weight: 60},
      { headerName: 'Vehicle No', exportHead: 'Vehicle No', field: 'VehicleNo', xlCol: { dataType: 'string', dataFormatter: null, minCellWidth: 5 }, weight: 50},
      { headerName: 'Challan No.', exportHead: 'Challan No.', field: 'ChallanNo', xlCol: { dataType: 'string', dataFormatter: null, minCellWidth: 5 }, weight: 45},
      { headerName: 'Pay. Type', exportHead: 'Pay. Type', field: 'PaymentType', xlCol: { dataType: 'quantity', dataFormatter: null, minCellWidth: 5 }, weight: 50},
      { headerName: 'Cons. Type', exportHead: 'Cons. Type', field: 'DescriptionDet', xlCol: { dataType: 'quantity', dataFormatter: null, minCellWidth: 5 }, weight: 50},
      { headerName: 'Units', exportHead: 'Units', field: 'Quantity', xlCol: { dataType: 'quantity', dataFormatter: null, minCellWidth: 5 }, weight: 40},
      loginData?.intCompanyID !== RAJESH_TRANSPORT && { headerName: 'Gross Amount', exportHead: 'Gross\nAmount', field: 'NetAmount', xlCol: { dataType: 'quantity', dataFormatter: null, minCellWidth: 5 }, weight: 50
      },
    ].filter(Boolean)
  }

  const getFilteredTablePreviewColumns = () => {
    if (isGujaratCompany) {
      return getGujaratReceivePrintColumnDefs()
    }
    const columns = [
      { exportHead: 'SN', field: 'srNo', xlCol: { dataType: 'number', dataFormatter: null }, weight: 20 },
      { exportHead: 'LR No.', field: 'LRNO' , xlCol: { dataType: 'string', dataFormatter: null }, weight: 55},
      { exportHead: 'Manual LR', field: 'ManualLRNo' , xlCol: { dataType: 'string', dataFormatter: null }, weight: 55},
      { exportHead: 'Booking Date', field: 'BookingDateTime' , xlCol: { dataType: 'string', dataFormatter: null }, weight: 55},
      { exportHead: 'Cons. Type', field: 'DescriptionDet' , xlCol: { dataType: 'string', dataFormatter: null }, weight: 50},
      { exportHead: 'Pay. Type', field: 'PaymentType' , xlCol: { dataType: 'string', dataFormatter: null }, weight: 50},
      { exportHead: 'Units', field: 'Quantity' , xlCol: { dataType: 'number', dataFormatter: null }, weight: 40},
      { exportHead: 'Sender', field: 'Sender' , xlCol: { dataType: 'string', dataFormatter: null }, weight: 70},
      { exportHead: 'Receiver', field: 'RecName' , xlCol: { dataType: 'string', dataFormatter: null }, weight: 70},
      { exportHead: 'Source', field: 'FromCity' , xlCol: { dataType: 'string', dataFormatter: null }, weight: 70},
      { exportHead: 'Destination', field: 'ToCity' , xlCol: { dataType: 'string', dataFormatter: null }, weight: 70},
      { exportHead: 'Challan', field: 'ChallanNo' , xlCol: { dataType: 'string', dataFormatter: null }, weight: 50},
      loginData?.intCompanyID !== RAJESH_TRANSPORT && { exportHead: 'Gross Amount', field: 'NetAmount' , xlCol: { dataType: 'number', dataFormatter: null }, weight: 50},
    ]

    return columns.filter(Boolean)
  }

  const getFilteredTablePreviewRows = () => {
    if (isGujaratCompany) {
      let totalAmount = 0
      let totalShort = 0
      let totalDamage = 0

      const rows = (filteredTableRows || []).map((item) => {
        const amount = Number(item?.NetAmount || 0)
        const shortQty = Number(item?.ShortQty ?? 0)
        const damageQty = Number(item?.DamageQty ?? 0)
        totalAmount += amount
        totalShort += shortQty
        totalDamage += damageQty

        return {
          LRNO: item?.LRNO || '',
          Sender: item?.Sender || '',
          RecName: item?.RecName || '',
          FromCity: item?.FromCity || '',
          ToCity: item?.ToCity || '',
          DescriptionDet: getConsignmentType(item),
          NetAmount: amount,
          PaymentType: item?.PaymentType || '',
          ShortQty: shortQty,
          DamageQty: damageQty,
          Comments: item?.Comments || '',
          dataType: 'entry',
        }
      })

      rows.push({
        LRNO: 'Total',
        NetAmount: totalAmount,
        ShortQty: totalShort,
        DamageQty: totalDamage,
        dataType: 'total',
        colSpan: { LRNO: 6 },
        align: { LRNO: 'right' },
      })

      return rows
    }

    let totalUnits = 0
    let totalAmount = 0

    const rows = (filteredTableRows || []).map((item, index) => {
      const quantity = Number(item?.Quantity || 0)
      const amount = Number(item?.NetAmount || 0)
      totalUnits += quantity
      totalAmount += amount

      return {
        srNo: index + 1,
        LRNO: item?.LRNO || '',
        ManualLRNo: item?.ManualLRNo || '',
        BookingDateTime: formatPreviewDate(item?.BookingDateTime),
        DescriptionDet: item?.ConsignmentData?.length === 1 ? item?.DescriptionDet || '' : 'Multi',
        PaymentType: item?.PaymentType || '',
        Quantity: quantity,
        Sender: item?.Sender || '',
        RecName: item?.RecName || '',
        FromCity: item?.FromCity || '',
        ToCity: item?.ToCity || '',
        ChallanNo: item?.ChallanNo || '',
        NetAmount: amount,
        dataType:'entry'
      }
    })

    rows.push({
      srNo: 'Total',
      Quantity: totalUnits,
      NetAmount: totalAmount,
      dataType: 'total',
      colSpan: { srNo: 6 },
      align: { srNo: 'right' }
    })

    return rows
  }

  const generateFilteredTablePreviewPdf = (isSave = false) => {
    if (!filteredTableRows?.length) {
      setState((prev) => ({ ...prev, filteredPreviewGeneratePDF: false }))
      updateModal(false)
      handleAlert(rs.noFilteredReceiveRowsFound)
      return
    }

    jsPDF.API.events.push(['addFonts', callAddFontRobotoBold])
    jsPDF.API.events.push(['addFonts', callAddFontRobotoMedium])

    const pdfFontSize = 1.214
    // const pdfFontOptions = { isLargeRowHeight: true, isIncreFontSize: loginData?.intCompanyID === GUJRAT_COMPANY_ID ? 2 : 1, fontName: 'Nirmala' }
    const columnDefs = getFilteredTablePreviewColumns()
    const orientation = columnDefs.length > 14 ? 'l' : 'p'
    const format = orientation === 'l' ? [1810, 1280] : [1280, 1810]
    const pdfColumns = withPxWidths(columnDefs, format[0] - 60).map((col) => {
      return { header: col.exportHead, dataKey: col.field, xlCol: col.xlCol, width: col.width || 0, ...(col.align ? { align: col.align } : {}) }
    })

    const previewRows = getFilteredTablePreviewRows()
    const doc = new jsPDF({ orientation: orientation, format: format, unit: 'px', compress: true })

    const totalPagesExp = '{total_pages_count_string}'
    doc.setProperties({
      title: `Receive Filter Preview.pdf`,
      subject: 'Receive Filter Preview',
      author: 'Maven Tech Labs Pvt. Ltd.',
      keywords: 'maven tech, Cargo system, Receive',
      creator: 'MTLPL',
    })
    const customFunction = (data, doc) => {
      doc.setTextColor(40)
      doc.addImage('/images/logo-66.png', 'JPEG', 30, 50, 50, 50)
      doc.setFontSize(26).setFont('Roboto', 'bold')
      doc.setTextColor(16, 79, 162)
      doc.text(`Cargo System | Receive Filter Preview`, 30 + 60, 80)
      doc.setTextColor(0, 0, 0)
      doc.setFontSize(22).setFont('Roboto', 'bold')
      doc.text(`Company Name :${loginData.strCompanyName}`, doc.internal.pageSize.width - data.settings.margin.left, 80, 'right')
      lrDetailPdfFooter(data, loginData, totalPagesExp)
    }

    makeTable(doc, autoTable, pdfColumns, previewRows, pdfFontSize, 'Receive Filter Preview', loginData, 'everyPage', customFunction, 120, true, false, true, { isLargeRowHeight: true, isIncreFontSize: isGujaratCompany ? 2 : 1, ...(isGujaratCompany ? { lineColor: [0, 0, 0] } : {}) })
    if (typeof doc.putTotalPages === 'function') {
      doc.putTotalPages(totalPagesExp)
    }

    const pdfUrl = doc.output('bloburl')
    setFilteredPreviewPdfUrl(pdfUrl)

    if (isSave) {
      doc.save(`Receive Filter Preview ${moment(new Date()).format('DD-MMM-YYYY HH-mm')}.pdf`)
    }

    setState((prev) => ({ ...prev, filteredPreviewGeneratePDF: false }))
  }
  const getPDFData = () => {
    const updateData = [...receiveMemoResult]
    let UnitsTotal = 0
    let GrossAmt = 0
    let ShortQtyTotal = 0
    let DamageQtyTotal = 0
    const todayDate = new Date().toString().split(' ')
    const year = todayDate[3]
    const day = todayDate[2]
    const month = todayDate[1]
    updateData?.forEach((item, i) => {
      item.srNo = i + 1
      item.ReceivedDate = `${day}-${month}-${year}`
      item.DescriptionDet = getConsignmentType(item)
      item.ShortQty = Number(item?.ShortQty ?? 0)
      item.DamageQty = Number(item?.DamageQty ?? 0)
      item.Comments = item?.Comments || ''
      UnitsTotal += item.Quantity
      GrossAmt += item.NetAmount
      ShortQtyTotal += item.ShortQty
      DamageQtyTotal += item.DamageQty
      item.dataType = 'entry'
    })
    if (isGujaratCompany) {
      updateData.push({
        LRNO: 'Total',
        NetAmount: GrossAmt,
        ShortQty: ShortQtyTotal,
        DamageQty: DamageQtyTotal,
        dataType: 'total',
        colSpan: { LRNO: 6 },
        align: { LRNO: 'right' },
      })
      // updateData.unshift({
      //   colSpan: { LRNO: 6, NetAmount: 5 },
      //   align: { LRNO: 'left', NetAmount: 'left' },
      //   LRNO: `Destination City : ${updateData?.[0]?.ToCity}`,
      //   NetAmount: `Destination Branch : ${updateData?.[0]?.DestinationBranchName}`,
      //   dataType: 'subHeader',
      //   totalSubKey: 2,
      // })
      return updateData
    }
    updateData.push({
      srNo: 'Total',
      Quantity: UnitsTotal,
      NetAmount: GrossAmt,
      dataType: 'total',
      colSpan: { srNo: 12 },
      align: { srNo: 'right' }
    })
    updateData.unshift({
      colSpan: { srNo: 7, RecName: loginData?.intCompanyID !== RAJESH_TRANSPORT ? 7 : 6 },
      align: { srNo: 'left', RecName: 'left' },
      srNo: `Destination City : ${updateData?.[0]?.ToCity}`,
      RecName: `Destination Branch : ${updateData?.[0]?.DestinationBranchName}`,
      dataType: 'subHeader',
      totalSubKey: 2,
    })
    return updateData
  }
  
  const printClick = async () => {

    if (receiveMemoResult === undefined || receiveMemoResult.length <= 0) {
      updateModal(false, 'LastReceivePrint')
      handleAlert(rs.noReceiveFound)
    } else {
      setState({ ...state, load: true, generatePDF: true })
      jsPDF.API.events.push(['addFonts', callAddFontRobotoBold])
      jsPDF.API.events.push(['addFonts', callAddFontRobotoMedium])

      const updateData = await getPDFData()
      // const pdfFontOptions = { isLargeRowHeight: true, isIncreFontSize: loginData?.intCompanyID === GUJRAT_COMPANY_ID ? 2 : 1, fontName: 'Nirmala' }
      const columnDefs = getReceivePrintColumnDefs()
      const customFunction = (data, doc) => {
        doc.setTextColor(40)
        doc.addImage('/images/logo-66.png', 'JPEG', 30, 50, 50, 50)
        doc.setFontSize(26).setFont('Roboto', 'bold')
        doc.setTextColor(16, 79, 162)
        doc.text(`Cargo System | Receive Report`, 30 + 60, 80)
        doc.setTextColor(0, 0, 0)
        doc.setFontSize(22).setFont('Roboto', 'bold')
        doc.text(`Company Name :${loginData.strCompanyName}`, doc.internal.pageSize.width - data.settings.margin.left, 80, 'right')
        lrDetailPdfFooter(data, loginData, totalPagesExp)
      }
      const pdfFontSize = isGujaratCompany ? 1.214 : 1
      const orientation = isGujaratCompany || ReceiveChallanPortrait ? 'p' : 'l'
      const format = orientation === 'l' ? [1810, 1280] : [1280, 1810]
      const pdfColumns = withPxWidths(columnDefs, format[0] - 60).map((col) => {
        return { header: col.exportHead, dataKey: col.field, xlCol: col.xlCol, width: col.width || 0, ...(col.align ? { align: col.align } : {}) }
      })
      const doc = new jsPDF({ orientation: orientation, format: format, unit: 'px', compress: true })
      if (!isGujaratCompany) {
        doc.autoTableSetDefaults({
          headStyles: { fontSize: 6, width: 'auto', halign: 'left', fillColor: [30, 89, 167] },
        })
      }

      var totalPagesExp = '{total_pages_count_string}'
    
      doc.setProperties({
        title: `Receive.pdf`,
        subject: 'Receive Summary Report',
        author: 'Maven Tech Labs Pvt. Ltd.',
        keywords: 'maven tech, Cargo system, Receive',
        creator: 'MTLPL',
      })

       makeTable(doc, autoTable, pdfColumns, updateData, pdfFontSize, 'Receive Report', loginData, 'everyPage', customFunction, 120, true, false, true, { isLargeRowHeight: true, isIncreFontSize: isGujaratCompany ? 2 : 1, ...(isGujaratCompany ? { lineColor: [0, 0, 0] } : {}) })      
       if (typeof doc.putTotalPages === 'function') {
        doc.putTotalPages(totalPagesExp)
      }
      setTimeout(() => {
        setState({ ...state, generatePDF: false, load: true })
        const pdfUrl = doc.output('bloburl')
        document.getElementById('receiveOutput').data = pdfUrl
      }, 2000)
    }
  }

  const getShortReceivePDFData = () => {
    const updateData = [...shortReceiveMemoResult]
    let shortUnitTotal = 0
    let otherChargeTotal = 0
    let totalAmount = 0
    updateData?.forEach((item, i) => {
      item.srNo = i + 1
      shortUnitTotal += Number(item.ShortQty) || 0
      otherChargeTotal += Number(item.OtherCharge) || 0
      totalAmount += Number(item.NetAmount) || 0
      item.dataType = 'entry'
    })
    updateData.push({
      srNo: 'Total',
      ShortQty: shortUnitTotal,
      OtherCharge: otherChargeTotal,
      NetAmount: totalAmount,
      dataType: 'total',
      colSpan: { srNo: 10 },
      align: { srNo: 'right' },
    })
    return updateData
  }

  const shortReceivePrintClick = async () => {
    if (shortReceiveMemoResult === undefined || shortReceiveMemoResult.length <= 0) {
      updateModal(false, 'ShortReceiveSuccess')
      handleAlert(rs.noReceiveFound)
    } else {
      setState({ ...state, load: true, generatePDF: true })
      jsPDF.API.events.push(['addFonts', callAddFontRobotoBold])
      jsPDF.API.events.push(['addFonts', callAddFontRobotoMedium])

      const updateData = await getShortReceivePDFData()
      const columnDefs = [
        {
          headerName: 'SR',
          exportHead: 'SR',
          field: 'srNo',
          xlCol: { dataType: 'number', dataFormatter: null, minCellWidth: 5 },
          weight: 20,
        },
        {
          headerName: 'LR No.',
          exportHead: 'LR No.',
          field: 'LRNO',
          xlCol: { dataType: 'string', dataFormatter: null, minCellWidth: 5 },
          weight: 55,
        },
        {
          headerName: 'Pay Type',
          exportHead: 'Pay Type',
          field: 'PaymentType',
          xlCol: { dataType: 'string', dataFormatter: null, minCellWidth: 5 },
          weight: 45,
        },
        {
          headerName: 'Dispatch Date',
          exportHead: 'Dispatch\nDate',
          field: 'BookingDateTime',
          xlCol: { dataType: 'string', dataFormatter: null, minCellWidth: 5 },
          weight: 50,
        },
        {
          headerName: 'Short Receive Date',
          exportHead: 'Short Receive\nDate',
          field: 'ShortReceiveDate',
          xlCol: { dataType: 'string', dataFormatter: null, minCellWidth: 5 },
          weight: 50,
        },
        {
          headerName: 'Sender',
          exportHead: 'Sender',
          field: 'Sender',
          xlCol: { dataType: 'string', dataFormatter: null, minCellWidth: 5 },
          weight: 55,
        },
        {
          headerName: 'Receiver',
          exportHead: 'Receiver',
          field: 'RecName',
          xlCol: { dataType: 'string', dataFormatter: null, minCellWidth: 5 },
          weight: 55,
        },
        {
          headerName: 'From City',
          exportHead: 'From City',
          field: 'FromCity',
          xlCol: { dataType: 'string', dataFormatter: null, minCellWidth: 5 },
          weight: 50,
        },
        {
          headerName: 'To City',
          exportHead: 'To City',
          field: 'ToCity',
          xlCol: { dataType: 'string', dataFormatter: null, minCellWidth: 5 },
          weight: 50,
        },
        {
          headerName: 'Vehicle',
          exportHead: 'Vehicle',
          field: 'VehicleNo',
          xlCol: { dataType: 'string', dataFormatter: null, minCellWidth: 5 },
          weight: 55,
        },
        {
          headerName: 'Short Unit',
          exportHead: 'Short\nUnit',
          field: 'ShortQty',
          xlCol: { dataType: 'quantity', dataFormatter: null, minCellWidth: 5 },
          weight: 40,
        },
        {
          headerName: 'Other Charge',
          exportHead: 'Other\nCharge',
          field: 'OtherCharge',
          xlCol: { dataType: 'quantity', dataFormatter: null, minCellWidth: 5 },
          weight: 45,
        },
        {
          headerName: 'Total Amount',
          exportHead: 'Total\nAmount',
          field: 'NetAmount',
          xlCol: { dataType: 'quantity', dataFormatter: null, minCellWidth: 5 },
          weight: 50,
        },
        {
          headerName: 'Received By User',
          exportHead: 'Received By\nUser',
          field: 'ReceivedByUser',
          xlCol: { dataType: 'string', dataFormatter: null, minCellWidth: 5 },
          weight: 60,
        },
        {
          headerName: 'Short Received By Branch',
          exportHead: 'Short Received\nBy Branch',
          field: 'ShortReceivedByBranch',
          xlCol: { dataType: 'string', dataFormatter: null, minCellWidth: 5 },
          weight: 70,
        },
      ]
      const customFunction = (data, doc) => {
        doc.setTextColor(40)
        doc.addImage('/images/logo-66.png', 'JPEG', 30, 50, 50, 50)
        doc.setFontSize(26).setFont('Roboto', 'bold')
        doc.setTextColor(16, 79, 162)
        doc.text(`Cargo System | Short Receive Report`, 30 + 60, 80)
        doc.setTextColor(0, 0, 0)
        doc.setFontSize(22).setFont('Roboto', 'bold')
        doc.text(`Company Name :${loginData.strCompanyName}`, doc.internal.pageSize.width - data.settings.margin.left, 80, 'right')
        lrDetailPdfFooter(data, loginData, totalPagesExp)
      }
      const pdfFontSize = 1
      const orientation = ReceiveChallanPortrait ? 'p' : 'l'
      const format = orientation === 'l' ? [1810, 1280] : [1280, 1810]
      const pdfColumns = withPxWidths(columnDefs, format[0] - 60).map((col) => {
        return { header: col.exportHead, dataKey: col.field, xlCol: col.xlCol, width: col.width || 0 }
      })
      const doc = new jsPDF({ orientation: orientation, format: format, unit: 'px', compress: true })
      doc.autoTableSetDefaults({
        headStyles: { fontSize: 6, width: 'auto', halign: 'left', fillColor: [30, 89, 167] },
      })

      var totalPagesExp = '{total_pages_count_string}'

      doc.setProperties({
        title: `ShortReceive.pdf`,
        subject: 'Short Receive Summary Report',
        author: 'Maven Tech Labs Pvt. Ltd.',
        keywords: 'maven tech, Cargo system, Short Receive',
        creator: 'MTLPL',
      })

      makeTable(
        doc,
        autoTable,
        pdfColumns,
        updateData,
        pdfFontSize,
        'Short Receive Report',
        loginData,
        'everyPage',
        customFunction,
        120,
        true,
        false,
        true,
        { isLargeRowHeight: true, isIncreFontSize: loginData?.intCompanyID === GUJRAT_COMPANY_ID ? 2 : 1 }
      )
      if (typeof doc.putTotalPages === 'function') {
        doc.putTotalPages(totalPagesExp)
      }
      setTimeout(() => {
        setState({ ...state, generatePDF: false, load: true })
        const pdfUrl = doc.output('bloburl')
        document.getElementById('shortReceiveOutput').data = pdfUrl
      }, 2000)
    }
  }

  const receiveClick = async (id) => {
    switch (id) {
      case 'Receivebtn':
        if (selectedData.length < 1) {
          handleAlert(error.SELECT_LR)
        } else {
          if ([1,2].includes(LITReceive)) {
            setModal('ReceivedSecond')
          } else {
            updateModal(true, 'Receive')
          }
        }
        break
      case 'ShortReceivebtn':
        if (selectedData.length < 1) {
          handleAlert(error.SELECT_LR)
        } else {
          updateModal(true, 'ShortReceive')
        }
        break
      case 'confirmShortReceive': {
        const shortbookingIds = BookingId.join('^').toString()
        const shortDispatchIds = DispatchDetIDs.join('^').toString()
        const shortShortQtyss = shortQtys.join('^').toString()
        const shortObj = {
          strBookingIDs: shortbookingIds,
          strDispatchIDS: shortDispatchIds,
          strShortQtys: shortShortQtyss,
          strComments: Remarks,
        }
        const todayDate = new Date().toString().split(' ')
        const shortReceiveDate = `${todayDate[2]}-${todayDate[1]}-${todayDate[3]}`
        const printRows = (selectedData || []).map((item) => ({
          LRNO: item.LRNO,
          PaymentType: item.PaymentType,
          BookingDateTime: item.BookingDateTime,
          ShortReceiveDate: shortReceiveDate,
          Sender: item.Sender,
          RecName: item.RecName,
          FromCity: item.FromCity,
          ToCity: item.ToCity,
          VehicleNo: item.VehicleNo,
          ShortQty: item.Quantity ?? 0,
          OtherCharge: item.OtherCharge,
          NetAmount: item.NetAmount,
          ReceivedByUser: loginData?.strUserName,
          ShortReceivedByBranch: strtBrnch?.BranchName || loginData?.strBranchName,
        }))
        updateModal(false, 'ShortReceive')
        const result = await setFetchShortReceive({ loginData, shortObj, printRows })
        if (!result?.ok) {
          handleAlert(result?.message)
        }
        break
      }
      case 'confirmReceive':
        const receivebookingIds = BookingId.join('^').toString()
        const LRno = LrNo.join('^').toString()
        const dispatchId = DipatchIDs.join('^').toString()
        const dispatchDetId = DispatchDetIDs.join('^').toString()
        const shortQtyss = shortQtys.join('^').toString()
        const DamageQtys = damageQtys.join('^').toString()
        if ([1, 2].includes(LITReceive)) {
          const data = {
            strBookingIDs: receivebookingIds,
            strDipatchIDs: dispatchId,
            intNewCityID: loginData.intBranchCityID,
            intNewBranchID: loginData.intBranchID,
            intUserID: loginData.intUserID,
            intCompanyID: loginData.intCompanyID,
            intIsApp: 2,
          }
          PostRequest(urls.getReceiveSecond, data).then((res) => {
            if (res.status === 'Success') {
              setAlert({ show: true, msg: rs.lrReceivedSuccessfully, success: true, nextId: '' })
            } else {
              setAlert({ show: true, msg: rs.lrReceiveFailed, nextId: '' })
            }
          }).catch((err) => {
            console.log(err)
          }).finally(() => {
            setModal('')
            setReceiveLITLrList([])
          })
        } else {
          // if (showListAll) {
          //   const vehicleGroup = groupData('VehicleID', receiveListData)
            
          //   let disID = selelectedData.map(({ BookingID }) => BookingID)
          //   const vehicleDate = topSelectedData.SelectedVehicle.VehicleWithDetail.split(':')
          //   const dtDate = dateFormatWithInputData(vehicleDate[1].split('-'), 'yyyy-MM-dd')
          //   const body = {
          //     SendingCityID: topSelectedData.DFromCity.CityID,
          //     ReceivedCityID: strtCity.CityID,
          //     SendingBranchID: topSelectedData.DFromBranch.BranchID,
          //     ReceivedBranchID: strtBrnch.BranchID,
          //     CompanyID: loginData.intCompanyID,
          //     VehicleNo: topSelectedData.SelectedVehicle.VehicleNo,
          //     Date: dtDate,
          //     VoucherNo: 0,
          //     // VoucherNo: Number(selectedChallan?.VoucherNo),
          //     ConsignmentTypeID: tSecDropData.selectconsignmentType === 'All' ? 0 : tSecDropData.selectconsignmentType.ConsignmentSubTypeID,
          //     VehicleID: topSelectedData.SelectedVehicle.VehicleID,
          //     UserID: loginData.intUserID,
          //     Remarks: Remarks,
          //     IsReceiveAllLrs: receiveListData?.length === selelectedData?.length ? 1 : 0,
          //     ExceptionDispatchIDs: receiveListData
          //       ?.filter((item) => !disID?.includes(item.BookingID))
          //       ?.map((obj) => obj?.DispatchID)
          //       ?.join('^'),
          //     ExceptionDispatchDetIDs: receiveListData
          //       ?.filter((item) => !disID?.includes(item.BookingID))
          //       ?.map((obj) => obj?.DispatchDetID)
          //       ?.join('^'),
          //   }
          //   console.log('showListAll', body,showListAll,receiveListData,selelectedData)
          //   // getReceiveUpdateReceiveAllV2(body)
            
          // } 
          if (showListAll) {
            // selected LR ids
            const selectedIDs = selelectedData.map(x => String(x.BookingID))
            // group by vehicle, dispatch date/time, and source branch
            const vehicleGroup = groupDataByKeys(['VehicleID', 'DispatchDateTime', 'FromBranchID'], receiveListData)
            const bodyArray = []
            Object.values(vehicleGroup).forEach(vehicleItems => {
              if (!vehicleItems?.length) return
              // ❗ unselected LR ids for the vehicle
              const unChecked = vehicleItems.filter(
                lr => !selectedIDs.includes(String(lr.BookingID))
              )
              // exception ids
              const exceptionDispatchIDs = unChecked.map(x => x.DispatchID).join('^')
              const exceptionDispatchDetIDs = unChecked.map(x => x.DispatchDetID).join('^')
              const dtDate = getDispatchDate(vehicleItems[0])
              const body = {
                SendingCityID: vehicleItems[0].FromCityID,
                ReceivedCityID: strtCity.CityID,
                SendingBranchID: vehicleItems[0].FromBranchID,
                ReceivedBranchID: strtBrnch.BranchID,
                CompanyID: loginData.intCompanyID,
                VehicleNo: vehicleItems[0].VehicleNo,
                Date: dtDate,
                VoucherNo: 0,
                ConsignmentTypeID:tSecDropData.selectconsignmentType === 'All'? 0: tSecDropData.selectconsignmentType?.ConsignmentSubTypeID,
                VehicleID: vehicleItems[0].VehicleID,
                UserID: loginData.intUserID,
                Remarks: Remarks,
                // ⭐ core logic
                IsReceiveAllLrs: unChecked.length === 0 ? 1 : 0,
                ExceptionDispatchIDs: exceptionDispatchIDs,
                ExceptionDispatchDetIDs: exceptionDispatchDetIDs,
              }
              bodyArray.push(body)
            })
            setInsertReceiveAll([bodyArray, selelectedData]).then((result) => {
              if (result && result.success === false && result.msg) {
                handleAlert(result.msg)
              }
            })
          } else {
            const group=groupData('FromBranchID', selectedData)
            const arr=[];
            Object.values(group).forEach((item)=>{
              const receivebookingIds = item.map((itm) => itm.BookingID).join('^').toString()
              const LRno = item.map((itm) => itm.LRNO).join('^').toString()
              const dispatchId = item.map((itm) => itm.DispatchID).join('^').toString()
              const dispatchDetId = item.map((itm) => itm.DispatchDetID).join('^').toString()
              const shortQtyss = item.map((itm) => 0).join('^').toString()
              const DamageQtys = item.map((itm) => 0).join('^').toString()
              const receiveObj = {
              strBookingIDs: receivebookingIds,
              intSendingCityID: item[0].FromCityID,
              intReceivedCityID: strtCity.CityID,
              intSendingBranchID: item[0].FromBranchID,
              intReceivedBranchID: strtBrnch.BranchID,
              strVehicleNo: item[0].VehicleNo,
              strRemarks: Remarks,
              VehicleID: item[0].VehicleID,
              strDispatchDetIDs: dispatchDetId,
              strDipatchIDs: dispatchId,
              strLRNos: LRno,
              strShortQtantities: shortQtyss,
              strDamageQtys: DamageQtys,
              strDispatchedVehicleNo: '',
              intCompanyID: loginData.intCompanyID,
              intUserID: loginData.intUserID,
              intIsApp: 2,
            }
            // getReceiveUpdateReceive(loginData, receiveObj)
            arr.push(receiveObj)
            })
            setInsertReceive([arr,selectedData]).then((result) => {
              if (result && result.success === false && result.msg) {
                handleAlert(result.msg)
              }
            })
          }
          setResetFlag(!resetFlag)
          // setSelectedPrintData(null)
          // setSelectedPrintData(selectedData)
          setState({
            ...state,
            dFromBranchForPrint: topSelectedData?.DFromBranch?.BranchName,
            lastReceivePrint: false,
            load: false,
            generatePDF: false,
          })
          updateModal(false, 'Receive')
        }
        break
      case 'lastReceivePrint':
        printClick()
        break
      default:
        break
    }
  }
  const handleKeyDownConfirm = (e, id) => {
    if (e.keyCode === 37) {
      if (id == "receiveConfirmNo") {
        focusElemnt("receiveConfirmYes")
      } else if (id == "receiveConfirmYes") {
        focusElemnt("receiveConfirmNo")
      }
    } else if (e.keyCode === 39) {
      if (id == "receiveConfirmNo") {
        focusElemnt("receiveConfirmYes")
      } else if (id == "receiveConfirmYes") {
        focusElemnt("receiveConfirmNo")
      }
    }
  }
  const handleKeyDownSuccess = (e, id) => {
    if (e.keyCode === 37) {
      if (id == "receiveSuccessNo" || id == "shortReceiveSuccessNo") {
        focusElemnt(id == "shortReceiveSuccessNo" ? "shortReceiveSuccessYes" : "receiveSuccessYes")
      } else if (id == "receiveSuccessYes" || id == "shortReceiveSuccessYes") {
        focusElemnt(id == "shortReceiveSuccessYes" ? "shortReceiveSuccessNo" : "receiveSuccessNo")
      }
    } else if (e.keyCode == 39) {
      if (id == "receiveSuccessNo" || id == "shortReceiveSuccessNo") {
        focusElemnt(id == "shortReceiveSuccessNo" ? "shortReceiveSuccessYes" : "receiveSuccessYes")
      } else if (id == "receiveSuccessYes" || id == "shortReceiveSuccessYes") {
        focusElemnt(id == "shortReceiveSuccessYes" ? "shortReceiveSuccessNo" : "receiveSuccessNo")
      }
    }
  }
  const ReceiveModal = (isRecve = false) => {
    return (
      <Modal headTxt={cs.confirm} width={'25%'} updateModal={updateModal}>
        <Stack>
          <Box style={{ margin: '20px', fontSize: '16px' }}>
            <div>
              {rs.dispatchReceiveConfirm
                .replace('{{fromBranch}}', topSelectedData?.DFromBranch?.BranchName || '')
                .replace('{{toBranch}}', strtBrnch?.BranchName || '')}
            </div>
          </Box>
        </Stack>
        <Stack>
          {/* background: '#f15a22' */}
          <div className="modal-btn-grp">
            <button
              className="select-lr-btn"
              autoFocus={true}
              // id="deliveryyes"
              id='receiveConfirmYes'
              style={{ background: '#fe5200', color: 'white', padding: '7px 20px', cursor: 'pointer', fontSize: '12px' }}
              onClick={() => receiveClick('confirmReceive')}
              onKeyDown={(e) => handleKeyDownConfirm(e, 'receiveConfirmYes')}
            >
              {cs.yes}
            </button>
            <Button
              id='receiveConfirmNo'
              className="select-lr-btn"
              variant="outlined"
              color="error"
              // autoFocus={true}
              onClick={() => updateModal(false, 'Receive')}
              onKeyDown={(e) => handleKeyDownConfirm(e, 'receiveConfirmNo')}
              style={{ cursor: 'pointer', fontSize: '12px' }}
            >
             {cs.no}
            </Button>
          </div>
        </Stack>
      </Modal>
    )
  }
  const ReceiveSecondModal = () => {
    return (
      <Modal headTxt={cs.confirm} width={'35%'} updateModal={updateModal}>
        <Stack>
         {/*TO DO */}
          <Box style={{ margin: '20px', fontSize: '19px' }}>
            <div>
              {rs.dispatchReceiveForConfirm.replace(
                '{{ref}}',
                LITReceive === 1
                  ? `${rs.vehicleNoLabel} ${topSelectedData?.SelectedVehicle?.VehicleNo || ''}`
                  : `${rs.lrNoLabel} ${selectedData?.[0]?.LRNO || ''}`
              )}
              {/* {`Please confirm you want to dispatch receive consignment/s for ${
                LITReceive === 1 ? 'Vehicle No. ' + topSelectedData?.SelectedVehicle?.VehicleNo : 'LR No. ' + selectedData?.[0].LRNO
              }`} */}
            </div>
          </Box>
        </Stack>
        <Stack>
          {/* background: '#f15a22' */}
          <div className="modal-btn-grp">
            <button
              autoFocus
              id="deliveryyes"
              style={{ background: '#fe5200', color: 'white', padding: '7px 20px', cursor: 'pointer' }}
              onClick={() => receiveClick('confirmReceive')}
            >
              {cs.yes}
            </button>
            <Button
              className="select-lr-btn"
              variant="outlined"
              color="error"
              onClick={() => setModal('')}
              style={{ cursor: 'pointer' }}
            >
             {cs.no}
            </Button>
          </div>
        </Stack>
      </Modal>
    )
  }
  const ReceiveSuccessModal = (isRecve = false) => {
    return (
      <Modal headTxt={rs.success} width={load ? '90%' : '25%'} updateModal={()=>{window.location.reload(false)}}>
        <>
          {load ? (
            ''
          ) : (
            <>
              <Stack>
                <Box style={{ margin: '20px', fontSize: '16px' }}>
                  <div>{rs.successfullReceive}</div>
                  <div>{rs.doYouWantPrint}</div>
                </Box>
              </Stack>
              <Stack>
                <div className="modal-btn-grp">
                  <button
                    // autoFocus
                    className="select-lr-btn"
                    id="receiveSuccessYes"
                    style={{ background: '#fe5200', cursor: 'pointer', color: 'white', padding: '7px 20px', fontSize: '16px' }}
                    onClick={() => { printClick(); focusElemnt('Receive_Dispatch_From_City') }}
                    onKeyDown={(e) => handleKeyDownSuccess(e, 'receiveSuccessYes')}
                  >
                    {cs.yes}
                  </button>
                  <Button
                    className="select-lr-btn"
                    variant="outlined"
                    id='receiveSuccessNo'
                    color="error"
                    autoFocus={true}
                    onClick={() => { updateModal(false, 'ReceiveSuccess'); focusElemnt('Receive_Dispatch_From_City');window.location.reload(false); }}
                    onKeyDown={(e) => handleKeyDownSuccess(e, 'receiveSuccessNo')}
                    style={{ cursor: 'pointer', fontSize: '16px' }}
                  >
                    {cs.no}
                  </Button>
                </div>
              </Stack>
            </>
          )}
          {generatePDF ? <div className={'generatePDF'}>{cs.pdfGenerationMsg}</div> : ''}
          {load ? (
            <object
              id="receiveOutput"
              type="application/pdf"
              width="1330"
              height="600"
              title={rs.afterTransferSummaryReportPdfTitle}
              aria-label={rs.afterTransferSummaryReportPdfTitle}
            ></object>
          ) : (
            ''
          )}
        </>
      </Modal>
    )
  }

  const ShortReceiveModal = (isRecve = false) => {
    return (
      <Modal headTxt={cs.confirm} width={'25%'} updateModal={updateModal}>
        <Stack>
          <Box style={{ margin: '20px', fontSize: '16px' }}>
            <div>
              {rs.shortDispatchReceiveConfirm
                .replace('{{fromBranch}}', topSelectedData?.DFromBranch?.BranchName || '')
                .replace('{{toBranch}}', strtBrnch?.BranchName || '')}
            </div>
          </Box>
        </Stack>
        <Stack>
          {/* background: '#f15a22' */}
          <div className="modal-btn-grp">
            <button
              autoFocus
              id="deliveryyes"
              style={{ background: '#fe5200', color: 'white', padding: '7px 20px', cursor: 'pointer', fontSize: '12px' }}
              onClick={() => receiveClick('confirmShortReceive')}
            >
              {cs.yes}
            </button>
            <Button
              className="select-lr-btn"
              variant="outlined"
              color="error"
              onClick={() => updateModal(false, 'ShortReceive')}
              style={{ cursor: 'pointer', fontSize: '12px' }}
            >
             {cs.no}
            </Button>
          </div>
        </Stack>
      </Modal>
    )
  }
  const ShortReceiveSuccessModal = (isRecve = false) => {
    if (!allowShortReceivePrint) {
      return (
        <Modal headTxt={rs.success} width={'25%'} updateModal={() => { window.location.reload(false) }}>
          <Stack>
            <Box style={{ margin: '20px', fontSize: '16px' }}>
              <div>{rs.successfullShortReceiveOfSelectedLR}</div>
            </Box>
          </Stack>
          <Stack>
            <div className="modal-btn-grp">
              <button
                autoFocus
                className="select-lr-btn"
                id="shortReceiveSuccessOk"
                style={{ background: '#fe5200', cursor: 'pointer', color: 'white', padding: '7px 20px', fontSize: '16px' }}
                onClick={() => { updateModal(false, 'ShortReceiveSuccess'); focusElemnt('Receive_Dispatch_From_City'); window.location.reload(false); }}
              >
                {cs.ok}
              </button>
            </div>
          </Stack>
        </Modal>
      )
    }
    return (
      <Modal headTxt={rs.success} width={load ? '90%' : '25%'} updateModal={() => { window.location.reload(false) }}>
        <>
          {load ? (
            ''
          ) : (
            <>
              <Stack>
                <Box style={{ margin: '20px', fontSize: '16px' }}>
                  <div>{rs.successfullShortReceiveOfSelectedLR}</div>
                  <div>{rs.doYouWantPrint}</div>
                </Box>
              </Stack>
              <Stack>
                <div className="modal-btn-grp">
                  <button
                    className="select-lr-btn"
                    id="shortReceiveSuccessYes"
                    style={{ background: '#fe5200', cursor: 'pointer', color: 'white', padding: '7px 20px', fontSize: '16px' }}
                    onClick={() => { shortReceivePrintClick(); focusElemnt('Receive_Dispatch_From_City') }}
                    onKeyDown={(e) => handleKeyDownSuccess(e, 'shortReceiveSuccessYes')}
                  >
                    {cs.yes}
                  </button>
                  <Button
                    className="select-lr-btn"
                    variant="outlined"
                    id="shortReceiveSuccessNo"
                    color="error"
                    autoFocus={true}
                    onClick={() => { updateModal(false, 'ShortReceiveSuccess'); focusElemnt('Receive_Dispatch_From_City'); window.location.reload(false); }}
                    onKeyDown={(e) => handleKeyDownSuccess(e, 'shortReceiveSuccessNo')}
                    style={{ cursor: 'pointer', fontSize: '16px' }}
                  >
                    {cs.no}
                  </Button>
                </div>
              </Stack>
            </>
          )}
          {generatePDF ? <div className={'generatePDF'}>{cs.pdfGenerationMsg}</div> : ''}
          {load ? (
            <object
              id="shortReceiveOutput"
              type="application/pdf"
              width="1330"
              height="600"
              title={rs.afterTransferSummaryReportPdfTitle}
              aria-label={rs.afterTransferSummaryReportPdfTitle}
            ></object>
          ) : (
            ''
          )}
        </>
      </Modal>
    )
  }

  const LastReceivePrint = (isRecve = false) => {
    return (
      <Modal headTxt={rs.lastReceivePrint} width={load ? '90%' : '25%'} updateModal={updateModal}>
        {load ? (
          ''
        ) : (
          <>
            <Stack>
              <Box style={{ margin: '20px', fontSize: '16px' }}>
                <div>{rs.doYouWantToLastReceivePrint}</div>
              </Box>
            </Stack>
            <Stack>
              <div className="modal-btn-grp">
                <button
                  autoFocus
                  id="deliveryyes"
                  style={{ background: '#fe5200', cursor: 'pointer', color: 'white', padding: '7px 20px', fontSize: '12px' }}
                  onClick={() => receiveClick('lastReceivePrint')}
                >
                  {cs.yes}
                </button>

                <Button
                  className="select-lr-btn"
                  variant="outlined"
                  color="error"
                  onClick={() => updateModal(false, 'LastReceivePrint')}
                  style={{ cursor: 'pointer', fontSize: '12px' }}
                >
                 {cs.no}
                </Button>
              </div>
            </Stack>
          </>
        )}
        {generatePDF ? <div className={'generatePDF'}>{cs.pdfGenerationMsg}</div> : ''}
        {load ? (
          <object
            id="receiveOutput"
            type="application/pdf"
            width="1330"
            height="600"
            title={rs.afterTransferSummaryReportPdfTitle}
            aria-label={rs.afterTransferSummaryReportPdfTitle}
          ></object>
        ) : (
          ''
        )}
      </Modal>
    )
  }

  const ReceivedItemList = (isRecve = false) => {
    return (
      <Modal headTxt={rs.receivedItemList} width={'95%'} updateModal={updateModal}>
        <Stack>
          <ReceivedItem handleAlert={handleAlert} />
        </Stack>
      </Modal>
    )
  }
  const FilteredTablePreviewModal = () => {
    return (
      <Modal
        headTxt={rs.receiveFilterPreview}
        headText2={`${filteredTableRows.length} ${rs.rowsFrom} ${filteredTableSource || rs.receiveTable}`}
        width={'95%'}
        updateModal={updateModal}
      >
        <>
          {filteredPreviewGeneratePDF ? <div className={'generatePDF'}>Generating PDF....</div> : ''}
          <Stack direction="row" spacing={2} style={{ padding: '12px 16px 0 16px', justifyContent: 'flex-end' }}>
            <Button
              variant="outlined"
              style={{ borderColor: '#fe5200', color: '#fe5200', fontSize: '13px', fontWeight: 'bold', marginBottom:'10px' }}
              onClick={() => generateFilteredTablePreviewPdf(true)}
              disabled={!filteredTableRows?.length || filteredPreviewGeneratePDF}
            >
              {rs.downloadPdf}
            </Button>
          </Stack>
          {filteredPreviewPdfUrl ? (
            <object
              id="receiveFilteredPreviewOutput"
              type="application/pdf"
              width="100%"
              height="650"
              data={filteredPreviewPdfUrl}
              title={`MTLPL - ${cs.cargoSystem} - ${rs.receiveFilterPreview}`}
              aria-label={`MTLPL - ${cs.cargoSystem} - ${rs.receiveFilterPreview}`}
            ></object>
          ) : (
            <div style={{ padding: '24px', minHeight: '200px' }}>
              {filteredPreviewGeneratePDF ? '' : rs.preparingPreview}
            </div>
          )}
        </>
      </Modal>
    )
  }
  const onKeyDown = (id, e) => {
    switch (id) {
      case 'ReceiveBtn':
        if (e.key === 'Enter') {
        } else if (e.key === 'Escape') {
          focusElemnt('receiveRemarks')
        }
        break
      case 'remarks':
        if (e.key === 'Enter') {
          focusElemnt('Receivebtn')
        } else if (e.key === 'Escape') {
          focusElemnt('receiveShowList')
        }
        break
      default:
        break
    }
  }
  return (
    <>
      <div className="bottom-section" style={{ width: '100%' }}>
        <Stack
          direction="row"
          divider={
            <Divider
              orientation="vertical"
              sx={{
                width: '2px',
                margin: '0px -16px 0px 0px !important',
                //   backgroundColor: "#0086ff",
                backgroundColor: '#DDD',
              }}
              flexItem
            />
          }
          spacing={2}
          sx={{ background: '#f0fcf4', width: '100%' }}
        >
          <Item sx={{ width: '30%', paddingTop: '16px', background: '#f0fcf4' }}>
            <Box
              sx={{
                flexGrow: 1,
                width: '100%',
                display: 'inline-flex',
                padding: '0% 10px',
                background: '#f0fcf4',
              }}
            >
              <Item sx={{ width: '100%', background: '#f0fcf4' }}>
                <div className={'input--wrapper'}>
                  <LineInput
                    id="receiveRemarks"
                    type="text"
                    name={'SenGstnNo'}
                    label={rs.remarks}
                    value={Remarks}
                    onChange={(e) => setState({ ...state, Remarks: e.target.value })}
                    // disabled={true}
                    // onKeyDown={(e) => onKeyDown('remarks', e)}
                    onKeyDown={(e) => navigation3(e, 'Receivebtn', 'checkbox_0', () => {})}
                  />
                </div>
              </Item>
            </Box>
          </Item>
          <Item sx={{ width: '70%', paddingTop: '16px', background: '#f0fcf4' }}>
            <Box
              sx={{
                flexGrow: 1,
                width: '100%',
                display: 'flex',
                padding: '0% 10px',
                // marginTop: "15px",
                background: '#f0fcf4',
              }}
            >
              {[JAIN_NEW, JAIN_COMPANY_ID].includes(loginData.intCompanyID) ? (
                <></>
              ) : (
                <>
                  {/* {loginData.intCompanyID === GUJRAT_COMPANY_ID && ( */}
                    <Item sx={{ width: '100%', background: '#f0fcf4' }}>
                      <Button
                        variant="outlined"
                        sx={{ width: '100%' }}
                        style={{
                          borderColor: filteredTableRows?.length ? '#fe5200' : '#cccccc',
                          color: filteredTableRows?.length ? '#fe5200' : '#000',
                          fontSize: '15px',
                          fontWeight: 'bold',
                          textTransform: 'Uppercase',
                        }}
                        onClick={() => {
                          if (!filteredTableRows?.length) {
                            handleAlert(rs.noFilteredReceiveRowsFound)
                            return
                          }
                          setFilteredPreviewPdfUrl('')
                          setState((prev) => ({ ...prev, filteredPreviewGeneratePDF: true }))
                          updateModal(true, 'FilteredTablePreview')
                        }}
                        disabled={!filteredTableRows?.length}
                      >
                        {cs.print}
                      </Button>
                    </Item>
                  {/* )} */}
                  <Item sx={{ width: '100%', background: '#f0fcf4' }}>
                    <Button
                      variant="outlined"
                      sx={{ width: '100%' }}
                      style={{ borderColor: '#fe5200', color: '#fe5200', fontSize: '15px', fontWeight: 'bold', textTransform: 'Uppercase' }}
                      onClick={() => updateModal(true, 'ReceivedItemList')}
                    >
                     {rs.receivedItemLists}
                    </Button>
                  </Item>
                </>
              )}
              <Item sx={{ width: '100%', background: '#f0fcf4' }}>
                <Button
                  variant="outlined"
                  sx={{ width: '100%' }}
                  style={{ borderColor: '#fe5200', color: '#fe5200', fontSize: '15px', fontWeight: 'bold', textTransform: 'Uppercase' }}
                  onClick={() => {
                    setState({ ...state, load: false, generatePDF: false, lastReceivePrint: true })
                    updateModal(true, 'LastReceivePrint')
                  }}
                >
                  {rs.lastReceivePrint}
                </Button>
              </Item>
              <Item sx={{ width: '100%', background: '#f0fcf4' }}>
                <Button
                  variant="outlined"
                  sx={{ width: '100%' }}
                  style={{
                    borderColor: [1, 2].includes(LITReceive) || roleRights.Table1?.[0].AllowShortReceipt !== 1 ? '#cccccc' : '#fe5200',
                    color: [1, 2].includes(LITReceive) || roleRights.Table1?.[0].AllowShortReceipt !== 1 ? '#000' : '#fe5200',
                    fontSize: '15px',
                    fontWeight: 'bold',
                    textTransform: 'Uppercase',
                  }}
                  onClick={() => receiveClick('ShortReceivebtn')}
                  disabled={[1, 2].includes(LITReceive) || roleRights.Table1?.[0].AllowShortReceipt !== 1 ? true : false}
                >
                  {rs.shortReceive}
                </Button>
              </Item>
              <Item sx={{ width: '100%', background: '#f0fcf4' }}>
                <Button
                  variant="contained"
                  id="Receivebtn"
                  sx={{ width: '100%' }}
                  style={{ backgroundColor: '#fe5200', fontSize: '15px', textTransform: 'Uppercase', color: '#fff', fontWeight: 'bold' }}
                  onClick={() => receiveClick('Receivebtn')}
                  onKeyDown={(e) => navigation3(e, 'Receive_Dispatch_From_City', 'receiveRemarks', () => {})}
                >
                  {rs.receive}
                </Button>
              </Item>
            </Box>
          </Item>
        </Stack>
      </div>
      {showModal && [successModal.Receive.id].includes(modalType) && ReceiveModal(successModal.Receive.id)}
      {'ReceivedSecond' === modal && ReceiveSecondModal()}
      {receivePrintPopup && ReceiveSuccessModal()}
      {showModal && [successModal.ShortReceive.id].includes(modalType) && ShortReceiveModal(successModal.ShortReceive.id)}
      {showModal && [successModal.LastReceivePrint.id].includes(modalType) && LastReceivePrint(successModal.LastReceivePrint.id)}
      {showModal && [successModal.ReceivedItemList.id].includes(modalType) && ReceivedItemList(successModal.ReceivedItemList.id)}
      {showModal && 'FilteredTablePreview'===modalType && FilteredTablePreviewModal()}
      {showModal &&
        [successModal.ShortReceiveSuccess.id].includes(modalType) &&
        ShortReceiveSuccessModal(successModal.ShortReceiveSuccess.id)}
    </>
  )
}

const mapStateToProps = (data) => ({ data })

const mapDispatchToProps = {
  updateModal,
  getReceiveUpdateReceive,
  getUpdateReceiveSecond,
  getReceiveLastReceivePrint,
  getReceiveUpdateReceiveAllV2
}

export default connect(mapStateToProps, mapDispatchToProps)(ReceiveBottomSection)
